import Modal from "@partials/UI/modal/modules/Modal";

/**
 * Получает HTML контент из template элемента
 * @param {string} templateId - ID template элемента
 * @returns {string} - HTML контент
 */
function getTemplateContent(templateId) {
    const template = document.getElementById(templateId);

    if (!template) {
        console.error(`Шаблон с ID "${templateId}" не найден`); // <-- Добавить эту строку
        return "";
    }

    const clone = template.content.cloneNode(true);
    const wrapper = document.createElement("div");
    wrapper.appendChild(clone);
    return wrapper.innerHTML;
}

/**
 * Обработчик клика на кнопки .btn_feedback
 * @param {Event} event - событие клика
 */
function handleFeedbackButtonClick(button) {
    const modalType = button.dataset.modal;

    if (!modalType) return;

    const templateId = `feedback-modal-${modalType}`;
    const templateContent = getTemplateContent(templateId);

    if (!templateContent) return;

    // Находим контейнер для контента
    const contentContainer = document.querySelector(".feedback-modal__content");
    if (!contentContainer) return;

    contentContainer.innerHTML = templateContent;

    // Добавляем обработчики для новых форм
    addFormHandlers();
    feedbackModal.open();
}

/**
 * Добавляет обработчики для форм в модальном окне
 * ВАЖНО: Используем ту же логику с reCAPTCHA что и в form.js
 */
function addFormHandlers() {
    // Импортируем функцию обработки форм с reCAPTCHA из form.js
    import("@partials/UI/form/form").then(({ onSubmitForm }) => {
        // Находим новые формы в модальном окне
        const newForms = document.querySelectorAll("#feedback-modal .form");

        newForms.forEach(form => {
            // Используем ТУ ЖЕ функцию что и для contact-формы (с reCAPTCHA!)
            form.addEventListener("submit", function (event) {
                event.preventDefault();
                onSubmitForm(form);
            });
        });
    });
}

// Создаем экземпляр модального окна
const feedbackModal = new Modal({
    selector: "#feedback-modal",
    close: "#feedback-modal .close",
    open: null,
    overlay: "#feedback-modal .overlay",
    hasForm: true
});

// Используем делегирование событий для надежности
// Это работает для всех кнопок .btn_feedback, включая динамически добавленные
document.addEventListener("click", function (event) {
    const feedbackButton = event.target.closest(".btn_feedback");

    if (feedbackButton) {
        handleFeedbackButtonClick(feedbackButton);
    }
});

export { feedbackModal };
